import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { loginRoutes } from './login.routing';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePasswordModule } from '../shared/change-password/change-password.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SlButtonTypeDirective } from '@sportlogiq/main/shared/directive/sl-button/sl-button.directive';
import { SlLoaderComponent } from '@sportlogiq/shared/sl-loader/sl-loader.component';
import { MatIconModule } from '@angular/material/icon';
import { SupportButtonComponent } from '../shared/support-button/support-button.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule.forChild(loginRoutes),
        TranslateModule,
        ChangePasswordModule,
        SlButtonTypeDirective,
        SlLoaderComponent,
        MatIconModule,
        SupportButtonComponent
    ],
    declarations: [LoginComponent],
})
export class LoginModule {}
